export default __webpack_public_path__ + "static/media/TimeControll.ba1b4269.jpg";